import { useState, useEffect } from 'react';
import { API_URLS } from '../../../apiUrl';
import { Pagination } from '@mui/material';
import WardEdit from '../../../editModals/wardEdit';
import axiosInstance from '../../../components/axiosInstance';

const WardList = ({ muniCipalityName, muniCipalityId }: any) => {
  const [wardTableData, setWardTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [inputData, setInputData] = useState({ page: 1, limit: 50 });
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage] = useState(50);

  useEffect(() => {
    const fetchWard = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axiosInstance.post(`${API_URLS.wardList}`, {
          municipalityTbl_id: muniCipalityId,
          page: inputData.page,
          limit: inputData.limit
        });

        setWardTableData(response.data.data.data);
        setTotalItems(response.data.data.total);
      } catch (err) {
        setError('Something went wrong!');
      } finally {
        setLoading(false);
      }
    };

    fetchWard();
  }, [inputData.page]);

  const filteredData = wardTableData.filter((item: any) =>
    item.ward_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.borough_name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handlePageChange = (event: any, value: number) => {
    setInputData((prevData) => ({
      ...prevData,
      page: value,
    }));
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [wardNo, setWardNo] = useState<any>("");
  const [wardId, setWardId] = useState<any>("");

  const openModal = (wardNo: any, wardId: any) => {
    setIsModalOpen(true);
    setWardId(wardId);
    setWardNo(wardNo);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="container mx-auto">
      <div className="flex gap-5 mb-4">
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Ward List ({muniCipalityName})</h1>

        <div className="flex justify-end md:w-4/12 w-full ml-auto">
          <input
            type="text"
            placeholder="Search..."
            className="border px-3 py-2 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-900 dark:bg-gray-800"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)} />
        </div>
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
        <table className="min-w-full table-auto">
          <thead className="bg-gray-100 border-b dark:border-gray-600 dark:bg-gray-700">
            <tr>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Borough</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Ward</th>
              <th className="py-3 px-6 text-center text-sm font-medium text-gray-600 dark:text-gray-100">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3} className="py-3 px-6 text-center">Loading...</td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan={3} className="py-3 px-6 text-center dark:bg-gray-800">No results found</td>
              </tr>
            ) : (
              filteredData.map((item: any, index) => (
                <tr key={index} className="border-b dark:border-gray-700 hover:bg-gray-50">
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.borough_name}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.ward_no}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600 text-center">
                    <div className="flex gap-2 justify-center">
                      <button onClick={() => openModal(item.ward_no, item.ward_primary_id)}  className="px-2 py-1.5 text-green-500 border border-green-200 rounded bg-green-100 hover:bg-green-200">
                        <i className="ri-edit-line"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {filteredData?.length === 0 ? null :
        <div className="flex justify-center mt-4">
          <Pagination
            count={totalPages}
            page={inputData.page}
            onChange={handlePageChange}
            color="primary"
          />
        </div>}
      <WardEdit isOpen={isModalOpen} closeModal={closeModal} muniCipalityName={muniCipalityName} muniCipalityId={muniCipalityId} wardNo={wardNo} wardId={wardId}/>
    </div>
  );
};

export default WardList;